<template>
  <footer class="footer">
    <div-container>
      <div class="columns content is-centered is-gapless is-flex-mobile is-multiline" style="margin-top:10px;" data-aos="fade-in" data-aos-once="true" data-aos-offset="-30">
        <p class="column is-8 is-12-touch copyright-wrapper is-hidden-touch">
          &copy; {{ year }} BOSS HOG COOK-OFF. All Rights Reserved. Website by <a href="http://adaptconcepts.com" target="_blank"><span style="border-bottom:1px solid black;">Adapt Concepts</span></a>
        </p>
        <p class="column is-4 is-12-touch social-wrapper">
          <span class="social">Follow us on social media</span>
          <a :href="navFacebook.path" target="_bank"><i class="fa fa-facebook"></i></a>
          <a :href="navTwitter.path" target="_bank"><i class="fa fa-twitter"></i></a>
          <a :href="navInstagram.path" target="_bank"><i class="fa fa-instagram"></i></a>
        </p>
        <p class="column is-8 is-12-touch copyright-wrapper is-hidden-desktop">
          &copy; {{ year }} BOSS HOG COOK-OFF. All Rights Reserved. Website by <a href="http://adaptconcepts.com" target="_blank"><span style="border-bottom:1px solid black;">Adapt Concepts</span></a>
        </p>
      </div>
    </div-container>
  </footer>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
export default {
  name: 'footer',
  components: {
    DivContainer
  },
  data () {
    return {
      navFacebook: EventBus._data._navFacebook,
      navTwitter: EventBus._data._navTwitter,
      navInstagram: EventBus._data._navInstagram
      // year: new Date().getFullYear()
    }
  },
  computed: {
    year: function () {
      return EventBus.info.year
    }
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target)
      }
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

footer, .footer {
  background-color: $color-orange;
  padding: 2rem 1.5rem 2rem;
  overflow: hidden;
}

footer {
  .columns {
    .column {
      .column-link {
        margin-bottom: 0.2em;
        a {
          padding: 0.5rem;
          color: $color-gray;

          &:hover {
            color: $color-gray-mid;
          }
        }
      }
    }
  }

  .content p {
    font-size: 0.8em;
    // text-align: center;
    color: $color-darkbrown;
  }

  span.social {
    margin-right: 15px;
  }

  .fa {
    font-size: 1.2rem;
    padding: 2px 8px;
    vertical-align: middle;
  }

  a {
    color: $color-darkbrown;

    &:hover {
      color: $color-gray;
    }
  }

  .columns.is-gapless > .column {
    .copyright-wrapper {
      text-align: center;
      margin-top: 1em;
      margin-bottom: 1em;
      @media screen and (min-width: $desktop) {
        text-align: left;
        margin-top: 0em;
        margin-bottom: 0em;
      }
    }

    .social-wrapper {
      text-align: center;
      @media screen and (min-width: $desktop) {
        text-align: right;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Footer.vue?5ef119ea